export default "__VITE_ASSET__G0xvS9AE__";